import { Link } from '@repo/web-ui/components/link'
import { useTranslations } from 'next-intl'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { useIsLoggedInQuery } from 'auth/hooks'
import { useHasAllAccessQuery } from '@repo/cf-user/hooks/use-user-data'

import { useClubhousesIsMemberQuery } from '@web/gen/clubhouses'
import { ClubhouseCard } from './clubhouse-card'
import { CLUBHOUSES } from '../../../_components/constants'

export function RecommendedClubhouses({
  clubhouseSlug,
  clubhouseName,
}: {
  clubhouseSlug?: string
  clubhouseName?: string
} = {}) {
  const t = useTranslations('pages.clubhouse.sidebar')
  const { data: isLoggedIn, isPending } = useIsLoggedInQuery()
  const { data: userHasAllAccess } = useHasAllAccessQuery()

  const { data: isMember } = useClubhousesIsMemberQuery(
    { input: { clubhouseSlug: clubhouseSlug || '' } },
    {
      select: data => data?.clubhousesIsClubhouseMember.isMember,
      enabled: !!clubhouseSlug,
    },
  )

  // If no clubhouseSlug is provided, show all clubhouses without member check
  const shouldShow = clubhouseSlug
    ? !isPending && isLoggedIn && isMember && userHasAllAccess
    : !isPending && isLoggedIn && userHasAllAccess

  const filteredClubhouses = clubhouseSlug
    ? CLUBHOUSES.filter(clubhouse => clubhouse.slug !== clubhouseSlug)
    : CLUBHOUSES.slice(0, 3)

  return shouldShow ? (
    <section>
      <div className="rounded-2 bg-cf-white flex w-full flex-col gap-3 border border-[#DADCE2] p-4 pt-5">
        <div className="flex flex-row justify-between">
          <h2 className="text-cf-sf-gray-1050 text-16 max-w-[171px] font-bold leading-[24px]">
            {t('recommended_clubhouses')}
          </h2>
          <Link
            className="text-14 text-cf-sf-gray-1100 hover:text-cf-sf-blue-100 font-medium leading-[20px] underline"
            href={AppRoutes.CLUBHOUSE}
          >
            {t('see_all')}
          </Link>
        </div>
        {clubhouseName ? (
          <div className="text-14 text-cf-sf-gray-1050 leading-[20px]">
            {t('people_who_like', { clubhouse: clubhouseName })}
          </div>
        ) : null}
        {filteredClubhouses.map(clubhouse => (
          <ClubhouseCard key={clubhouse.id} {...clubhouse} />
        ))}
      </div>
    </section>
  ) : null
}
